import Typography from 'components/Typography/Typography';

const RequestSubmitted = () => {
  return (
    <div className="flex flex-col h-screen">
      <img
        className="relative top-0 h-auto w-screen object-contain block xl:hidden"
        src="./assets/images/self-serve-mobile-bg.png"
        alt="first-project-modal-bg"
      />
      <div className="flex flex-col mt-24 xl:mt-0 items-center justify-center xl:h-screen">
        <img
          className="w-[197px] object-cover mx-auto mb-6"
          src="./assets/images/full-logo-black.svg"
          alt="self-serve-bg"
        />
        <Typography tag="h4">Request Submitted</Typography>
        <Typography className="text-center text-base-mutedForeground text-p-s mt-2">
          A representative will contact you soon.
        </Typography>
      </div>
    </div>
  );
};

export default RequestSubmitted;
